import { createAction, props } from '@ngrx/store';

export const showLoading = createAction('[Loading] show');

export const hideLoading = createAction('[Loading] hide');

export const clearLoading = createAction('[Loading] clear loading');

export const setProgress = createAction('[Loading] set progress', props<{ progress: number }>());
